import { render } from "./Trainer.vue?vue&type=template&id=746bef3c&scoped=true"
import script from "./Trainer.vue?vue&type=script&lang=js"
export * from "./Trainer.vue?vue&type=script&lang=js"

import "./Trainer.vue?vue&type=style&index=0&id=746bef3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746bef3c"]])

export default __exports__